import { ILogMessage } from '@bingads-webui/listener';

/**
 * Sink that is compatible with InMemoryListener.
 * Can be passed in to the listener to receive logs.
 */
export class InMemorySink {
  logs: ILogMessage[];

  maxSize: number;

  /**
   * Creates an instance of InMemorySink.
   * @param {Number} [maxSize=2000] - Maximum size of logs array.
   * Pass in -1 to have unbounded array.
   */
  constructor({ maxSize = 2000 }: { maxSize?: number } = {}) {
    this.logs = [];
    this.maxSize = maxSize;
  }

  /**
   * Write log to the sink
   * @param {ILogMessage} log - Log object to write
   * @returns {undefined} - no returns
   */
  write(log: ILogMessage): void {
    this.logs.push(log);

    while (this.maxSize > -1 && this.logs.length > this.maxSize) {
      this.logs.shift();
    }
  }

  /**
   * Getter for logs written to sink. Returns the
   * logs array.
   * @readonly
   */
  get items(): ILogMessage[] {
    return this.logs;
  }
}
